//import { AMTaxLogoGlobalWhite, LoginPage, MsalLoginForm } from "am-tax-fe-core";
import { FC, useEffect, useState } from "react";

import { Icon } from "@chakra-ui/react";
import { MsalLoginForm } from "am-tax-fe-core";

import BgImage from "../../assets/images/8C0862F6-1A5B-4941-8C67-874FCFAD2E05.jpg";
import EngageLogo from "../../assets/images/engage-logo-white-expanded.svg?react";
import { ReLoginModal } from "../../components/ReLoginModal";

import { LocalLoginPage } from "./LocalLoginPage";

interface Props {
    showMessage: boolean;
}
export const UnauthenticatedLandingPage: FC<Props> = ({ showMessage }) => {
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        setShowModal(true);
    }, []);

    const logo = <Icon as={EngageLogo} boxSize={{ base: "12rem", sm: "14rem", xl: "16rem", "2xl": "20rem" }} />;
    return (
        <>
            {showMessage && <ReLoginModal isOpen={showModal} onClose={() => setShowModal(false)} />}
            <LocalLoginPage bgImage={`url(${BgImage})`} appName={import.meta.env.VITE_APP_NAME} logo={logo}>
                <MsalLoginForm />
            </LocalLoginPage>
        </>
    );
};
